export default [
  {
    name: 'Dashboards',
    icon: 'nc-icon nc-bank',
    path: '/admin/overview',
    requireSupport: false,
    children: [
      {
        name: 'General',
        path: '/admin/overview'
      },
      {
        name: 'Reportes',
        path: '/admin/reports'
      },
      // {
      //   name: 'Socios',
      //   path: '/admin/memberships'
      // },
      // {
      //   name: 'Accesos',
      //   path: '/admin/Entries'
      // },
      // {
      //   name: 'Ventas',
      //   path: '/admin/sales'
      // },
    ]
  },
  {
    name: 'Socios & Membresías',
    icon: 'nc-icon nc-single-02',
    path: '/customers&memberships',
    requireSupport: false,
    children: [
      {
        name: 'Socios',
        path: '/customers&memberships/customers'
      }, {
        name: 'Membresías',
        path: '/customers&memberships/memberships'
      }, {
        name: 'Actualizador Masivo',
        path: '/customers&memberships/MMU'
      }
    ]
  },
  {
    name: 'Planes',
    icon: 'nc-icon nc-credit-card',
    path: '/plans',
    requireSupport: false,
    children: [
      {
        name: 'Creador',
        path: '/plans/create'
      },
      {
        name: 'Planes',
        path: '/plans/plansviewer'
      },
      {
        name: 'Turnos & Familias',
        path: '/plans/shifts&families'
      }
    ]
  },
  {
    name: 'Descargas',
    icon: 'nc-icon nc-cloud-download-93',
    path: '/downloads/win',
    requireSupport: false,
  },
  {
    name: 'Configuraciones',
    icon: 'nc-icon nc-settings-gear-65',
    path: '/settings',
    requireSupport: false,
    children: [
      {
        name: 'Puntos de Venta',
        path: '/settings/POS'
      },
      {
        name: 'Puntos de Acceso',
        path: '/settings/AP'
      },
      {
        name: 'Proc. Automáticos',
        path: '/settings/AutomaticProcesses'
      }
    ]
  },
  // {
  //   name: 'Ventas',
  //   icon: 'nc-icon nc-money-coins',
  //   path: '/sales',
  //   requireSupport: false
  // },
  {
    name: 'Pages',
    icon: 'nc-icon nc-book-bookmark',
    children: [
      {
        name: 'Timeline',
        path: '/pages/timeline'
      },
      {
        name: 'User Profile',
        path: '/pages/user'
      },
      {
        name: 'Login',
        path: '/login'
      },
      {
        name: 'Register',
        path: '/register'
      },
      {
        name: 'Lock',
        path: '/lock'
      }
    ],
    requireSupport: true
  },
  {
    name: 'Components',
    icon: 'nc-icon nc-layout-11',
    children: [{
      name: 'Buttons',
      path: '/components/buttons'
    },
    {
      name: 'Grid System',
      path: '/components/grid-system'
    },
    {
      name: 'Panels',
      path: '/components/panels'
    },
    {
      name: 'Sweet Alert',
      path: '/components/sweet-alert'
    },
    {
      name: 'Notifications',
      path: '/components/notifications'
    },
    {
      name: 'Icons',
      path: '/components/icons'
    },
    {
      name: 'Typography',
      path: '/components/typography'
    }],
    requireSupport: true
  },
  {
    name: 'Forms',
    icon: 'nc-icon nc-ruler-pencil',
    children: [{
      name: 'Regular Forms',
      path: '/forms/regular'
    },
    {
      name: 'Extended Forms',
      path: '/forms/extended'
    },
    {
      name: 'Validation Forms',
      path: '/forms/validation'
    },
    {
      name: 'Wizard',
      path: '/forms/wizard'
    }
    ],
    requireSupport: true
  },
  {
    name: 'Table List',
    icon: 'nc-icon nc-single-copy-04',
    collapsed: true,
    children: [{
      name: 'Regular Tables',
      path: '/table-list/regular'
    },
    {
      name: 'Extended Tables',
      path: '/table-list/extended'
    },
    {
      name: 'Paginated Tables',
      path: '/table-list/paginated'
    }
    ],
    requireSupport: true
  },
  {
    name: 'Maps',
    icon: 'nc-icon nc-pin-3',
    children: [{
      name: 'Google Maps',
      path: '/maps/google'
    },
    {
      name: 'Full Screen Maps',
      path: '/maps/full-screen'
    },
    {
      name: 'Vector Maps',
      path: '/maps/vector-map'
    }
    ],
    requireSupport: true
  },
  {
    name: 'Widgets',
    icon: 'nc-icon nc-box',
    path: '/admin/widgets',
    requireSupport: true
  },
  {
    name: 'Charts',
    icon: 'nc-icon nc-chart-bar-32',
    path: '/charts',
    requireSupport: true
  },
  {
    name: 'Calendar',
    icon: 'nc-icon nc-calendar-60',
    path: '/calendar',
    requireSupport: true
  },
]
